export const PoemFactorySettings = () => {
    return (
        <div id="008" className="">
            <p>looking for something that will</p>
            <p>break the cycle,</p>
            <p>well, not break the cycle, but loosen the sleeves,</p>
            <p>&amp; maybe unclench the jaw a little bit,</p>
            <p>always one look ahead and then a couple behind,</p>
            <p>out of every time i've looked to the past</p>
            <p>i don't think i've ever planned to do so on purpose.</p>
            <p>most things in theory look like stoves left on by accident -</p>
            <p>of course, you can't always just be the cause,</p>
            <p>sometimes you have to be the effect.</p>
            <p>i chose some of this but not all of it,</p>
            <p>how much was it me and how much was it</p>
            <p>inherited?</p>
            <p>how much was it passed on?</p>
            <p>how much was it chance?</p>
            <p>how right/wrong was ///that place/// in that specific time?</p>
            <p>it's like you might either arrive in a point</p>
            <p>or just find yourself there,</p>
            <br />
            <p>how much can you realistically get</p>
            <p>out of what you covet?</p>
            <p>most moments in practice</p>
            <p>look and feel like</p>
            <p>turning screws and tightening bolts,</p>
            <p>out of all the times i've ended up looking to the past,</p>
            <p>each time i wondered what should have been different,</p>
            <p>the present like a plastic wrapper,</p>
            <p>the answers are always in another room,</p>
            <p>
                and somehow the cost of searching always exceeds the estimates,
            </p>
            <p>the path looks straight only if you ignore the climb,</p>
            <p>
                i might carry some guilt and some guilt will always stick to the
                skin,
            </p>
            <p>each time i wished i knew everything,</p>
            <p>i found</p>
            <p>a caution sign in my plate</p>
            <p>the following day.</p>
        </div>
    );
};
